import SectionInfoBox from '../../../components/SectionInfoBox';

interface ProjectLocationInfoProps {
    project: any;
}

const ProjectLocationInfo: React.FC<ProjectLocationInfoProps> = ({ project }) => {
    return (
        <div id="location-details" className="mb-6 scroll-mt-32">
            <div className="bg-white rounded-xl p-3 md:p-4 shadow-[0_15px_35px_-12px_rgba(0,0,0,0.06)] border border-slate-100 relative overflow-hidden">
                {/* Decorative background elements */}
                <div className="absolute top-0 right-0 w-32 h-32 bg-slate-50 rounded-full blur-3xl -mr-16 -mt-16 opacity-50 pointer-events-none"></div>
                
                <div className="relative z-10">
                    {/* Header Section */}
                    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 mb-3 md:mb-5">
                        <div className="flex items-center">
                            <h2 className="text-xl md:text-2xl font-bold text-black tracking-tighter leading-none">
                                Location <span className="text-black">details</span>
                            </h2>
                            <SectionInfoBox text={project.sectionInfo?.location} />
                        </div>
                        <div className="flex items-center gap-2 bg-white px-3 py-1.5 rounded-lg border border-slate-100 shadow-md group shrink-0">
                            <i className="fa-solid fa-location-dot text-[#00B4FF] group-hover:scale-110 transition-transform text-[10px]"></i>
                            <span className="text-black font-bold text-[11px]">{project.city || 'Location Info'}</span>
                        </div>
                    </div>

                    <div className="flex flex-col gap-3">
                        {/* Project Address Card - Full Width */}
                        <div className="w-full">
                            <div className="bg-slate-50/50 rounded-lg p-4 md:p-5 border border-slate-100 flex flex-col md:flex-row md:items-center justify-between gap-6 group hover:bg-white hover:shadow-xl hover:shadow-slate-200/50 transition-all duration-500">
                                <div className="flex-1">
                                    <div className="flex items-center gap-4 mb-2.5">
                                        <div className="w-14 h-14 rounded-lg bg-[#001b4a] flex items-center justify-center text-white shadow-xl group-hover:rotate-6 transition-transform duration-500 shrink-0">
                                            <i className="fa-solid fa-map-pin text-xl"></i>
                                        </div>
                                        <div>
                                            <p className="font-medium text-black text-[11px] mb-0.5">Property Location</p>
                                            <h4 className="font-bold text-black text-[13px] leading-tight">Project Address</h4>
                                        </div>
                                    </div>
                                    <p className="text-black font-normal text-sm md:text-[16px] leading-snug max-w-2xl">
                                        {project.address || project.location || 'N/A'}
                                    </p>
                                </div>
                                <div className="shrink-0">
                                    <a 
                                        href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(project.address || project.location)}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="group inline-flex items-center gap-3 px-8 py-3 bg-white border-2 border-[#001b4a] rounded-lg text-[10px] font-bold text-[#001b4a] hover:bg-slate-50 hover:text-black hover:border-black transition-all shadow-xl hover:translate-y-[-1px] active:translate-y-0 w-full md:w-auto justify-center"
                                    >
                                        Get Directions
                                        <i className="fa-solid fa-arrow-right text-[9px] group-hover:translate-x-1 transition-transform"></i>
                                    </a>
                                </div>
                            </div>
                        </div>

                        {/* Stats Grid - Now Full Width & 4 Columns */}
                        <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 md:gap-3">
                            {[
                                { label: 'City Name', value: project.city || 'N/A', icon: 'fa-city', color: 'bg-blue-500 text-white' },
                                { label: 'Region / State', value: project.state || 'N/A', icon: 'fa-map-location-dot', color: 'bg-emerald-500 text-white' },
                                { label: 'Area Pincode', value: project.pinCode || 'N/A', icon: 'fa-envelope-open-text', color: 'bg-amber-500 text-white' },
                                { label: 'Primary Locality', value: project.location || 'N/A', icon: 'fa-street-view', color: 'bg-rose-500 text-white' }
                            ].map((item, idx) => (
                                <div key={idx} className="bg-white p-3 md:p-4 rounded-lg border border-slate-100 shadow-sm hover:shadow-lg transition-all duration-300 group flex flex-col items-center text-center justify-center min-h-[80px]">
                                    <div className={`w-11 h-11 md:w-12 md:h-12 rounded-lg flex items-center justify-center ${item.color} group-hover:scale-105 transition-transform duration-500 mb-2`}>
                                        <i className={`fa-solid ${item.icon} text-base md:text-lg`}></i>
                                    </div>
                                    <div className="w-full">
                                        <p className="text-[11px] md:text-[12px] font-bold text-black leading-none mb-1.5">{item.label}</p>
                                        <p className="text-[13px] md:text-[15px] font-bold text-black break-words leading-tight">{item.value}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProjectLocationInfo;




